var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge-wrapper"},[_vm._t("default"),_c('span',{staticClass:"badge-area",class:{ hidden: _vm.showOnHover, 'show-on-hover': _vm.showOnHover }},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }